export const Mapkey = 'AIzaSyAlPcCmX-WkEH4FGDZ-gf9tslZ9gVcpecU'
